export default __webpack_public_path__ + "static/media/snapshot.c83477c0.svg";